import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Form, Button, Card, Row, Col, Alert } from 'react-bootstrap';
import { FaEnvelope, FaKey } from 'react-icons/fa';
import { motion } from 'framer-motion';

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  
  const mainColor = '#006186';

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');
    setError('');
    setLoading(true);
    
    try {
      const response = await fetch('/api/auth/forgot-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email })
      });

      const data = await response.json();

      if (response.ok) {
        setMessage('Инструкции по восстановлению пароля отправлены на указанный адрес электронной почты');
        setTimeout(() => {
          navigate('/');
        }, 3000);
      } else {
        setError(data.error || 'Ошибка при восстановлении пароля');
      }
    } catch (err) {
      console.error('Ошибка восстановления:', err);
      setError('Ошибка соединения с сервером');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-light min-vh-100 d-flex align-items-center py-5">
      <Container>
        <Row className="justify-content-center">
          <Col lg={6} md={8}>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
            >
              <Card className="border-0 shadow-sm rounded-4 overflow-hidden">
                <div style={{ height: '4px', backgroundColor: mainColor }}></div>
                <Card.Body className="p-4 p-md-5">
                  <div className="text-center mb-4">
                    <div className="bg-light d-inline-block p-4 rounded-circle mb-3 border">
                      <FaKey size={32} style={{ color: mainColor }} />
                    </div>
                    <h2 className="fw-bold mb-2" style={{ color: '#1e293b', fontSize: '1.75rem' }}>
                      Восстановление пароля
                    </h2>
                    <p className="text-muted" style={{ fontSize: '0.875rem' }}>
                      Введите адрес электронной почты, указанный при регистрации. Инструкции по восстановлению пароля будут отправлены на этот адрес.
                    </p>
                  </div>

                  <Form onSubmit={handleSubmit}>
                    <Form.Group className="mb-4">
                      <Form.Label className="small fw-bold text-muted text-uppercase mb-2">
                        Электронная почта
                      </Form.Label>
                      <div className="d-flex align-items-center border rounded-3 bg-white" style={{ borderColor: '#e2e8f0' }}>
                        <div className="px-3 text-muted">
                          <FaEnvelope size={16} />
                        </div>
                        <Form.Control
                          type="email"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          placeholder="user@example.com"
                          className="border-0 bg-white py-2 shadow-none"
                          style={{ fontSize: '0.875rem' }}
                          required
                          disabled={loading}
                        />
                      </div>
                    </Form.Group>

                    {error && (
                      <Alert variant="danger" className="border-0 py-2 px-3 mb-3" style={{ fontSize: '0.875rem', backgroundColor: '#fee2e2', color: '#dc2626' }}>
                        {error}
                      </Alert>
                    )}

                    {message && (
                      <Alert variant="success" className="border-0 py-2 px-3 mb-3" style={{ fontSize: '0.875rem', backgroundColor: '#d1fae5', color: '#065f46' }}>
                        {message}
                      </Alert>
                    )}

                    <Button
                      type="submit"
                      disabled={loading}
                      className="w-100 py-2 fw-bold border-0"
                      style={{ 
                        backgroundColor: mainColor,
                        borderRadius: '8px',
                        fontSize: '0.875rem',
                        transition: 'all 0.2s'
                      }}
                      onMouseEnter={(e) => e.target.style.backgroundColor = '#004d66'}
                      onMouseLeave={(e) => e.target.style.backgroundColor = mainColor}
                    >
                      {loading ? 'Отправка...' : 'Восстановить пароль'}
                    </Button>
                  </Form>

                  <div className="text-center mt-4">
                    <Button
                      variant="link"
                      onClick={() => navigate('/')}
                      className="text-decoration-none p-0"
                      style={{ color: mainColor, fontSize: '0.875rem' }}
                    >
                      Вернуться на главную
                    </Button>
                  </div>
                </Card.Body>
              </Card>
            </motion.div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ForgotPassword;